import { Link } from "react-router-dom";
import { NAV, Socials, useTopBar } from "@/components/site/Navbar";
import { useApi } from "@/lib/api";
import { useLang } from "@/lib/i18n";

const PlaceLinks = ({ title, items, base, testId }) => {
  const { L, to } = useLang();
  return (
    <div className="md:col-span-2" data-testid={testId}>
      <p className="mb-5 text-xs font-bold uppercase tracking-[0.22em] text-sand"><Link to={to(`/${base}`)} className="hover:text-white" data-testid={`${testId}-index`}>{title}</Link></p>
      <ul className="space-y-3 font-semibold">
        {items.map((p) => (
          <li key={p.slug}><Link to={to(`/${base}/${p.slug}`)} className="hover:text-white" data-testid={`footer-${base}-${p.slug}`}>{L(p, "name")}</Link></li>
        ))}
      </ul>
    </div>
  );
};

export const Footer = () => {
  const { t, to } = useLang();
  const { data: places } = useApi("/places", []);
  const bar = useTopBar();
  return (
  <footer className="relative overflow-hidden bg-forest text-white/80 grain" data-testid="site-footer">
    <div className="container-x relative z-10 py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-logo text-5xl font-black tracking-tight text-white sm:text-7xl">Escamequita</p>
          <p className="mt-5 max-w-md text-base leading-relaxed">
            {t("footer.tagline")}
          </p>
          <Socials className="mt-8 text-white" />
          {bar?.label && bar?.url && (
            <a href={bar.url} target="_blank" rel="noopener" data-testid="footer-cortez-link"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-sand px-5 py-2.5 text-sm font-extrabold text-forest transition-colors duration-200 hover:bg-white">
              {bar.label} ↗
            </a>
          )}
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 text-xs font-bold uppercase tracking-[0.22em] text-sand">{t("footer.explore")}</p>
          <ul className="space-y-3">
            <li><Link to={to("/")} className="font-semibold hover:text-white" data-testid="footer-link-home">{t("footer.home")}</Link></li>
            {NAV.map((n) => (
              <li key={n.to}><Link to={to(n.to)} className="font-semibold hover:text-white" data-testid={`footer-link-${n.id}`}>{t(n.label)}</Link></li>
            ))}
          </ul>
        </div>
        <PlaceLinks title={t("footer.areas")} items={places.filter((p) => p.kind === "area")} base="areas" testId="footer-areas" />
        <PlaceLinks title={t("footer.activities")} items={places.filter((p) => p.kind === "activity")} base="things-to-do" testId="footer-activities" />
      </div>
      <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/15 pt-8 text-sm sm:flex-row">
        <p>© {new Date().getFullYear()} Escamequita.com — Escamequita, Rivas, Nicaragua</p>
        <Link to="/admin/login" className="text-white/50 hover:text-white" data-testid="footer-admin-link">{t("footer.owner")}</Link>
      </div>
      <p className="mb-14 mt-6 text-center text-xs text-white/55" data-testid="footer-credit">
        Heather (Blue) created this site and could not have completed it without <a href="https://www.gregmiceli.com" target="_blank" rel="noreferrer" className="font-semibold text-white/75 underline-offset-2 hover:text-white hover:underline" data-testid="footer-credit-link">www.GregMiceli.com</a>
      </p>
    </div>
  </footer>
  );
};
